import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div>Templates</div>",{ moduleName: "garaje/pods/emergency-response/incident-templates/template.hbs" })